<!-- TodaySummary.vue -->
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div>
					<el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-6">
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-6" v-if="false">
								<el-form-item label="Date Range:">
									<div class="block">
										<el-date-picker
										v-model="dateRange"
										type="daterange"
										align="right"
										size="small"
										unlink-panels
										range-separator="-"
										start-placeholder="Start date"
										end-placeholder="End date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
										</el-date-picker>
									</div>
								</el-form-item>
							</div>

							<div class="col-md-3">
								<el-form-item label="Year:" style="min-width:85px;">
									<el-select v-model="year" filterable clearable placeholder="Select Year" size="medium" style="width:100%;">
										<el-option v-for="item3 in getLastYears(5)" :key="item3.value" :label="item3.name" :value="item3.value">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-3">
								<el-form-item label="Month:" style="min-width:85px;">
									<el-select v-model="month" filterable clearable placeholder="Select Month" size="medium" style="width:100%;">
										<el-option v-for="item3 in getMonthList()" :key="item3.value" :label="item3.name" :value="item3.value">
										</el-option>
									</el-select>
								</el-form-item>
							</div>

							<div class="col-md-6" v-if="is2024OrBelow">
								<el-form-item label="Sales Area">
									<el-radio-group v-model="area" size="small" name="area">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-6" v-if="is2025OrAbove">
								<el-form-item label="Region">
									<el-radio-group v-model="region" size="small" name="region">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-6">
								<el-form-item label="COA ID/COA Name">
									<el-input v-model="coaname" maxlength="100"></el-input>
								</el-form-item>
							</div>

						</div>
						<div class="row">
							<div class="col-md-2">
								<el-form-item label="">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>

				<div class="row">
                    <div class="col-md-3 mb-2 mt-2">
                        <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                    </div>

					<div class="col-md-8 mt-2" v-if="showchart">
						<el-radio-group v-model="chartview" size="small" name="chartview">
							<el-radio-button :label="item5.value" v-for="(item5, index5) in options.chartview" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
						</el-radio-group>
					</div>
                </div>

				<div class="row" v-if="showchart">
					<div class="col-md-12">
						<div>
                            <BarChart :data="chartdata" :width="500" :height="380"/>
                            <Loader v-if="loading.table" />
                        </div>
					</div>
				</div>

				<div class="mt-0">
					<ReportResultTable :reportname="'PettyCashReport'"  :reportdata="reportdata" :loading="loading.table" :issuccess="loading.isSuccess" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, AppColors, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import TodaySummaryTable from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryTable.vue'

export default {
	extends: Finance,
	components: {
        ReportResultTable,
		BarChart,
		Loader,
        //TodaySummaryTable
	},
	data(){
		return {
            urlRequestParams: '',
            reportdata: { data: [] },  // Ensure it's an object with a 'data' property
            stationid: '',
            plant: '',
            spbu: {
                list: [],
            },
			options: {
				area:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				chartview:[
					{ value: "summary", name: "Summary" },
					{ value: "monthly", name: "Monthly Summary" },
					//{ value: "monthly_area", name: "Monthly Sales Area" },
					{ value: "monthly_region", name: "Monthly Region" },
					{ value: "monthly_coa", name: "Monthly COA" },
					//{ value: "area", name: "By Sales Area" },
					{ value: "region", name: "By Region" },
					{ value: "coa", name: "By COA" },
				],
			},
            loading: {
                table: false,
                isSuccess: false,
            },
            date: {
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin,
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin],
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			year: this.$route.query.year ? this.$route.query.year : Penanggalan().tahun,
			month: this.$route.query.month ? this.$route.query.month : Penanggalan().bulan,
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			coaname: '',

			chartdata: [],
			showchart: false,
			chartview: 'monthly',
			stacked: false,

			is2024OrBelow: false,
			is2025OrAbove: true,
        }
    },
    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList();
        this.getData();
    },
	watch: {
		chartview() {
			this.setChartView();
		},
		year(newValue, oldValue) {
			if(newValue >= 2025) {
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;
				this.area = '';
			} else {
				this.is2025OrAbove = false;
				this.is2024OrBelow = true;
				this.region = '';
			}
			//console.log('area: ' + this.area);
			//console.log('region: ' + this.region);
		},
	},
    methods: {
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},
        getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/pettycash/report?'
            this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')
            this.urlRequestParams+='&stationid='+this.stationid
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&region='+this.region
            this.urlRequestParams+='&coaname='+this.coaname

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;  // Update the data property of reportdata

					this.setChartView();
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
		setChartView() {
			let label = 'MonthName';
			let legend = 'Year';
			let amount = 'Amount';

			if(this.chartview == 'summary') {
				label = 'Year';
				legend = 'Year';
				amount = 'Amount';
			} else if(this.chartview == 'monthly') {
				label = 'MonthName';
				legend = 'Year';
				amount = 'Amount';
			} else if(this.chartview == 'monthly_area') {
				label = 'MonthName';
				legend = 'SalesArea';
				amount = 'Amount';
			}  else if(this.chartview == 'monthly_region') {
				label = 'MonthName';
				legend = 'RegionPertareId';
				amount = 'Amount';
			} else if(this.chartview == 'monthly_coa') {
				label = 'MonthName';
				legend = 'COAName';
				amount = 'Amount';
			} else if(this.chartview == 'area') {
				label = 'SalesArea';
				legend = 'Year';
				amount = 'Amount';
			}  else if(this.chartview == 'region') {
				label = 'RegionPertareId';
				legend = 'Year';
				amount = 'Amount';
			} else if(this.chartview == 'coa') {
				label = 'COAName';
				legend = 'Year';
				amount = 'Amount';
			}

			this.chartdata = this.processBarChart(this.reportdata.data, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
		},
        applyFilter() {
            this.getData()
        },
    }
}
</script>
